(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pp-charging-addons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-charging-addons')) {
    customElements.define('pp-charging-addons', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.syncAdapter();
        this.addEventListener('click', event => {
          const choice = event.target.closest('[data-extras-value]');
          if (!choice || !this.contains(choice)) return;
          const group = choice.closest('[data-extras-option]');
          group.dataset.value = choice.dataset.extrasValue;
          group.querySelectorAll('[data-extras-value]').forEach(button => {
            button.setAttribute('aria-pressed', String(button === choice));
          });
          this.dispatchEvent(new Event('change', { bubbles: true }));
        });
        this.addEventListener('change', () => {
          this.syncAdapter();
          this.querySelectorAll('[data-extras-variant]').forEach(select => {
            const row = select.closest('.pp-extras__row');
            const choices = [...row.querySelectorAll('[data-extras-option]')];
            const match = [...select.options].find(option => choices.every(choice => option.getAttribute('data-option-' + choice.dataset.optionIndex) === choice.dataset.value));
            const checkbox = row.querySelector('[data-extras-check]');
            if (!match || match.dataset.available !== 'true') {
              checkbox.checked = false;
              checkbox.disabled = true;
              row.querySelector('[data-extras-price]').textContent = this.dataset.unavailable;
              return;
            }
            select.value = match.value;
            checkbox.disabled = false;
            checkbox.dataset.variantId = match.value;
            row.querySelector('[data-extras-price]').textContent = match.dataset.price;
          });
          const button = this.querySelector('[data-extras-add]');
          if (button) button.disabled = !this.querySelector('[data-extras-check]:checked');
        });
        this.querySelector('[data-extras-add]')?.addEventListener('click', () => this.addSelected());
      }
      syncAdapter() {
        const row = this.querySelector('[data-stryker-row]');
        if (!row) return;
        const device = this.querySelector('[data-extras-device]');
        const eligible = device ? device.selectedOptions[0]?.dataset.stryker === 'true' : true;
        row.hidden = !eligible;
        const input = row.querySelector('[data-extras-check]');
        input.disabled = !eligible;
        if (!eligible) input.checked = false;
      }
      getItems(quantity = 1, deviceVariant = '') {
        this.syncAdapter();
        const device = this.querySelector('[data-extras-device]');
        const title = device ? device.selectedOptions[0]?.dataset.title : this.dataset.productTitle;
        const variant = device ? device.value : deviceVariant;
        return [...this.querySelectorAll('[data-extras-check]:checked:not(:disabled)')].map(input => ({
          id: input.dataset.variantId,
          quantity,
          properties: { 'For device': title || '', '_Device variant': String(variant || '') }
        }));
      }
      async addSelected(checkout = false) {
        if (this.busy) return;
        const items = this.getItems();
        if (!items.length) return;
        this.busy = true;
        const button = this.querySelector('[data-extras-add]');
        const original = button.textContent;
        const error = this.querySelector('[data-extras-error]');
        error.hidden = true;
        button.disabled = true;
        button.textContent = this.dataset.adding;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', {
            method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items})
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
          window.location.assign(checkout ? root + 'checkout' : this.dataset.cartUrl);
        } catch (e) {
          error.textContent = e.message || this.dataset.error;
          error.hidden = false;
          button.textContent = original;
          button.disabled = false;
          this.busy = false;
        }
      }
    });
    document.addEventListener('submit', event => {
      if (event.submitter?.name !== 'checkout') return;
      let extras;
      if (event.target.id === 'CartDrawer-Form') {
        extras = event.target.closest('cart-drawer')?.querySelector('pp-charging-addons[data-mode="cart"]');
      } else if (event.target.id === 'cart') {
        extras = document.querySelector('#main-cart-footer pp-charging-addons[data-mode="cart"]');
      }
      if (!extras?.querySelector('[data-extras-check]:checked')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      extras.addSelected(true);
    }, true);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-sticky-buy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-sticky-buy')) {
    customElements.define('pp-sticky-buy', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.section = document.getElementById('MainProduct-' + this.dataset.section) || this.closest('.shopify-section');
        if (!this.button || !this.section) return;
        this.basePadding = getComputedStyle(document.body).paddingBottom;
        this.frame = 0;
        this.queue = () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
        };
        this.submit = () => {
          this.sync();
          if (!this.button.disabled) this.main.click();
        };
        this.button.addEventListener('click', this.submit);
        this.observer = new MutationObserver((records) => {
          if (records.some(record => !this.contains(record.target))) this.queue();
        });
        this.observer.observe(document.body, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['disabled','aria-disabled','aria-busy','aria-hidden','class','style','hidden','open']});
        this.sizeObserver = new ResizeObserver(this.queue);
        this.sizeObserver.observe(this);
        addEventListener('scroll', this.queue, {passive:true});
        addEventListener('resize', this.queue, {passive:true});
        this.queue();
      }
      sync() {
        this.main = document.getElementById('ProductSubmitButton-' + this.dataset.section);
        if (!this.main) { this.setOpen(false); return; }
        const main = this.main;
        const busy = main.classList.contains('loading') || main.getAttribute('aria-busy') === 'true' || (main.form && main.form.getAttribute('aria-busy') === 'true');
        this.button.disabled = main.matches(':disabled') || main.getAttribute('aria-disabled') === 'true' || busy;
        this.button.setAttribute('aria-busy', String(busy));
        const label = (main.querySelector('span') || main).textContent.trim();
        if (label && this.button.textContent !== label) this.button.textContent = label;
        const total = this.section.querySelector('[data-pdp-total]');
        const price = document.getElementById('price-' + this.dataset.section);
        const current = total || (price && price.querySelector('.price--on-sale .price-item--sale, .price:not(.price--on-sale) .price__regular .price-item--regular'));
        const selection = this.section.querySelector('[data-pdp-selection]');
        [[current,'[data-price]'],[selection,'[data-selection]']].forEach(([source,selector]) => {
          const target = this.querySelector(selector);
          if (source && source.textContent.trim() && target.textContent !== source.textContent.trim()) target.textContent = source.textContent.trim();
        });
        const visible = node => {
          if (!node || !node.getClientRects().length) return false;
          for (let ancestor = node; ancestor; ancestor = ancestor.parentElement || ancestor.getRootNode().host) {
            if (ancestor.hidden || ancestor.getAttribute('aria-hidden') === 'true') return false;
            const style = getComputedStyle(ancestor);
            if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || Number(style.opacity) === 0) return false;
          }
          return true;
        };
        const blocked = Array.from(document.querySelectorAll('#pp-cc, dialog[open], [role="dialog"][aria-modal="true"], cart-drawer.active, cart-notification.active')).some(visible);
        const chat = document.querySelector('shopify-chat');
        if (chat && chat.shadowRoot && this.chatRoot !== chat.shadowRoot) {
          if (this.chatObserver) this.chatObserver.disconnect();
          this.chatRoot = chat.shadowRoot;
          this.chatObserver = new MutationObserver(this.queue);
          this.chatObserver.observe(this.chatRoot, {subtree:true, childList:true, attributes:true});
        }
        const chatOpen = this.chatRoot && Array.from(this.chatRoot.querySelectorAll('[role="dialog"], [aria-modal="true"], iframe')).some(node => visible(node) && node.getBoundingClientRect().height > 100);
        this.setOpen(innerWidth < 990 && main.getBoundingClientRect().bottom < 0 && !blocked && !chatOpen);
      }
      setOpen(open) {
        this.hidden = !open;
        const body = document.body;
        if (open) {
          const height = this.offsetHeight + 'px';
          if (body.style.getPropertyValue('--pp-sticky-h') !== height) body.style.setProperty('--pp-sticky-h', height);
          if (body.style.getPropertyValue('--pp-sticky-padding') !== this.basePadding) body.style.setProperty('--pp-sticky-padding', this.basePadding);
        }
        body.classList.toggle('pp-sticky-open', open);
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.sizeObserver) this.sizeObserver.disconnect();
        if (this.chatObserver) this.chatObserver.disconnect();
        cancelAnimationFrame(this.frame);
        removeEventListener('scroll', this.queue);
        removeEventListener('resize', this.queue);
        if (this.button) this.button.removeEventListener('click', this.submit);
        document.body.classList.remove('pp-sticky-open');
        document.body.style.removeProperty('--pp-sticky-h');
        document.body.style.removeProperty('--pp-sticky-padding');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
